import { EventV2 } from '@/services/EventService/abstract/EventV2';

export default class AuthRedirectToOtpEvent extends EventV2<string> {}
